export const NT_ADD = 'NT_ADD'

export const notificationsAdd = (payload) => ({
  payload,
  type: NT_ADD,
})
